<template>
  <mm-select :options="options"
  v-bind="$attrs" :value="value" v-on="$listeners"/>
</template>

<script>
export default {
	props:{
		value: {
			require: true,
		},
    dictType: {
      require: true,
    },
    defaultOptions: {
      default: () => {
        return [];
      }
    }
	},
  data(){
    const options = this.defaultOptions;
    return{
      options,
    }
  },
	async created(){
		const enumList = await this.getEnum();
		enumList.forEach((row) => {
			const item = this.options.find((r) => {
				return r.value == row.value;
			});
			if (!item) {
				this.options.push(row);
			}
		})
	},
  methods: {
    async getEnum() {
			if(!this.$cache[this.dictType+'_dict_list']) {
				const res = await this.$post('/dict/selectList',{
          type: this.dictType,
        })
        this.$cache[this.dictType+'_dict_list'] = res.map((row) => {
          return { value: row.name, label: (row.label || row.name) };
        });
			}
			return this.$cache[this.dictType+'_dict_list'];
    }
  }
}
</script>

